const cardItems = [
  {
    title: '古装必看：长风渡',
    desc: '白敬亭、宋轶演绎乱世商战传奇，权谋与爱情交织，口碑与热度双丰收的年度古装力作。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20elegant%20couple%20in%20traditional%20wedding%20attire%2C%20ancient%20Chinese%20mansion%20background%2C%20warm%20candlelight%20ambiance%2C%20romantic%20cinematic%20mood%2C%20rich%20red%20and%20gold%20color%20palette&width=800&height=500&seq=card-kk-01&orientation=landscape',
    alt: '长风渡精选推荐',
    tag: '口碑推荐',
  },
  {
    title: '悬疑力作：莲花楼',
    desc: '成毅携江湖奇案归来，单元案件环环相扣，武侠外壳下的硬核推理，燃烧你的追剧神经。',
    img: 'https://readdy.ai/api/search-image?query=martial%20arts%20mystery%20drama%20scene%2C%20lone%20warrior%20standing%20in%20misty%20bamboo%20forest%2C%20dramatic%20shafts%20of%20light%2C%20atmospheric%20fog%2C%20cool%20teal%20and%20warm%20amber%20contrast&width=800&height=500&seq=card-kk-02&orientation=landscape',
    alt: '莲花楼精选推荐',
    tag: '编辑力荐',
  },
  {
    title: '韩剧热播：欢迎来到三达里',
    desc: '治愈系韩剧新标杆，池昌旭、申惠善演绎济州岛上的温暖回归之旅，笑泪交织。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20warm%20romantic%20scene%2C%20couple%20on%20seaside%20village%20road%2C%20golden%20sunset%20lighting%2C%20cozy%20atmosphere%2C%20soft%20pastel%20tones%2C%20healing%20vibe&width=800&height=500&seq=card-kk-03&orientation=landscape',
    alt: '欢迎来到三达里精选推荐',
    tag: '韩剧精选',
  },
  {
    title: '甜宠天花板：偷偷藏不住',
    desc: '赵露思、陈哲远演绎从暗恋到双向奔赴的青春恋曲，甜度爆表，少女心收割机。',
    img: 'https://readdy.ai/api/search-image?query=youth%20romance%20drama%20scene%2C%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20campus%20background%2C%20soft%20spring%20lighting%2C%20sweet%20romantic%20atmosphere%2C%20warm%20pastel%20colors&width=800&height=500&seq=card-kk-04&orientation=landscape',
    alt: '偷偷藏不住精选推荐',
    tag: '甜宠必追',
  },
  {
    title: '谍战经典：潜行者',
    desc: '黄晓明、蒋欣主演谍战大戏，潜伏敌营步步惊心，烧脑剧情与紧张氛围拉满。',
    img: 'https://readdy.ai/api/search-image?query=spy%20thriller%20drama%2C%201940s%20Shanghai%20setting%2C%20man%20in%20trench%20coat%20under%20streetlamp%2C%20noir%20cinematic%20lighting%2C%20rainy%20night%20mood%2C%20suspenseful%20atmosphere&width=800&height=500&seq=card-kk-05&orientation=landscape',
    alt: '潜行者精选推荐',
    tag: '谍战经典',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1300px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          精选推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          编辑精心甄选，每一部都值得看
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-semibold bg-background-950/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer">
                  立即观看 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}